import { FC, ReactNode } from 'react';

import { css } from '@emotion/react';
import VError from 'verror';

import Layout from '~/components/shared/Layout';
import Navbar from '~/components/shared/Navbar';

import Main from './Main';
import Sidebar from './Sidebar';

interface ContainerProps {
  title?: string;
  pageError: (errorContext: any) => VError;
  menu: ReactNode;
  contentMaxWidth?: number;
}

const Container: FC<ContainerProps> = ({ children, title, pageError, menu, contentMaxWidth }) => {
  return (
    <Layout
      isContained={false}
      pageError={pageError}
      hasFooter={false}
      customNavbar={
        <Navbar
          isLoggedInOutContentVisible={false}
          toucanLogoUrl="/?noDashboardRedirect=true"
          customMobileMenuContent={menu}
          isContainerMaxWidthApplied={false}
        />
      }
    >
      <div
        css={css`
          display: flex;
        `}
      >
        <Sidebar menu={menu} />
        <Main title={title} contentMaxWidth={contentMaxWidth}>
          {children}
        </Main>
      </div>
    </Layout>
  );
};

export default Container;
